var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 400",
    style: {
      enableBackground: "new 0 0 800 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M800,160.9l-0.3-6.2c-7.2-38.4-42.1-67.6-84.2-67.6c-47.3,0-85.6,36.8-85.6,82.2c0,45.4,38.3,82.2,85.6,82.2 c1.9,0,3.9-0.1,5.8-0.2v-62.6c-2,0.5-4,0.7-6.1,0.7c-14.2,0-25.8-11.1-25.8-24.8c0-13.7,11.5-25.1,25.8-24.8 c18.1,0.5,20.7,15.3,20.7,15.3v93.9c0,0,0.1,0,0.2,0v0.6h64V160.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M393.7,160.9l-0.3-6.2c-7.2-38.4-42.1-67.6-84.2-67.6c-47.3,0-85.6,36.8-85.6,82.2c0,45.4,38.3,82.2,85.6,82.2 c1.9,0,3.9-0.1,5.8-0.2v-62.6c-2,0.5-4,0.7-6.1,0.7c-14.2,0-25.8-11.1-25.8-24.8c0-13.7,11.5-25.1,25.8-24.8 c18.1,0.5,20.7,15.3,20.7,15.3v93.9c0,0,0.1,0,0.2,0v0.6h64V160.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M406.7,187.9v58.5c0,0,58.2,3.7,76.1-42.6c11.9-52.7,29.5-48.1,29.5-48.1V96.2c0,0-40.8-0.6-62.4,16.4 c-21.6,17.1-18.3,45.1-19.2,45.4C429.8,158.3,431,176.9,406.7,187.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M516.3,187.9v58.5c0,0,58.2,3.7,76.1-42.6c11.9-52.7,29.5-48.1,29.5-48.1V96.2c0,0-40.8-0.6-62.4,16.4 c-21.6,17.1-18.3,45.1-19.2,45.4C539.5,158.3,540.7,176.9,516.3,187.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.8,
    y: 258.8,
    className: "st0",
    style: {
      fill: "#01538F"
    },
    width: 795.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M256.5,330.8c-2,1-6.1,2-11.3,2c-12.1,0-21.1-7.7-21.1-21.9c0-13.6,9.1-22.7,22.3-22.7 c5.3,0,8.7,1.2,10.2,1.9l-1.4,4.5c-2-1-5-1.8-8.6-1.8c-10,0-16.7,6.5-16.7,17.8c0,10.6,6,17.3,16.4,17.3c3.4,0,6.9-0.7,9.1-1.8 L256.5,330.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M274.9,332.8c-8.3,0-14.7-6.1-14.7-15.9c0-10.4,6.8-16.4,15.2-16.4c8.8,0,14.8,6.5,14.8,15.9 C290.2,327.8,282.3,332.8,274.9,332.8L274.9,332.8z M275.1,328.6c5.3,0,9.3-5.1,9.3-12.1c0-5.2-2.6-11.8-9.2-11.8 c-6.5,0-9.4,6.1-9.4,12C265.8,323.5,269.7,328.6,275.1,328.6L275.1,328.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M297.3,309.5c0-3.3-0.1-5.8-0.3-8.4h4.9l0.3,5h0.2c1.7-2.9,4.6-5.7,9.7-5.7c4.1,0,7.3,2.6,8.6,6.2h0.1 c1-1.8,2.2-3.1,3.5-4c1.8-1.4,3.8-2.2,6.7-2.2c4.1,0,10.2,2.7,10.2,13.4v18.2h-5.5v-17.5c0-6-2.2-9.5-6.7-9.5 c-3.2,0-5.6,2.4-6.7,5.1c-0.3,0.8-0.4,1.9-0.4,2.8v19.2h-5.5v-18.6c0-5-2.2-8.5-6.4-8.5c-3.4,0-6,2.8-6.9,5.6 c-0.3,0.8-0.4,1.8-0.4,2.8v18.7h-5.5V309.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M350.2,311.3c0-4-0.1-7.2-0.3-10.1h5l0.3,5.3h0.1c2.2-3.8,5.9-6,10.9-6c7.5,0,13.1,6.3,13.1,15.7 c0,11.1-6.8,16.6-14,16.6c-4.1,0-7.6-1.8-9.5-4.9h-0.1v16.8h-5.6V311.3z M355.8,319.5c0,0.8,0.1,1.6,0.3,2.3 c1,3.9,4.4,6.6,8.3,6.6c5.9,0,9.3-4.9,9.3-12c0-6.2-3.2-11.5-9.1-11.5c-3.8,0-7.4,2.7-8.5,6.9c-0.1,0.8-0.3,1.6-0.3,2.3V319.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M407.9,324.7c0,2.7,0.1,5.3,0.4,7.4h-5l-0.5-3.9h-0.2c-1.7,2.4-5,4.6-9.4,4.6c-6.2,0-9.4-4.4-9.4-8.9 c0-7.5,6.6-11.6,18.5-11.5v-0.6c0-2.6-0.7-7.2-7-7.2c-2.9,0-5.9,0.8-8.1,2.3l-1.3-3.8c2.5-1.6,6.3-2.7,10.2-2.7 c9.5,0,11.7,6.5,11.7,12.7V324.7z M402.5,316.3c-6.1-0.1-13,1-13,7c0,3.7,2.4,5.4,5.2,5.4c4.1,0,6.7-2.6,7.6-5.2 c0.2-0.6,0.3-1.2,0.3-1.8V316.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M416.9,309.5c0-3.3-0.1-5.8-0.3-8.4h5l0.3,5.1h0.1c1.5-2.9,5.1-5.8,10.2-5.8c4.3,0,10.9,2.6,10.9,13.2v18.5 h-5.6v-17.9c0-5-1.8-9.2-7.1-9.2c-3.6,0-6.5,2.6-7.5,5.8c-0.3,0.7-0.4,1.7-0.4,2.6v18.7h-5.6V309.5z M422.2,296.2 c0-1.9,0.3-3.5,1-4.5c0.8-1.2,1.8-1.9,3.1-1.9c1.5,0,2.5,0.6,4.1,1.5c1,0.6,1.8,1.1,2.9,1.1c1,0,1.5-0.6,1.7-2.7h2.8 c0.1,3.9-1.3,6.1-4.3,6.1c-1.4,0-2.6-0.6-3.9-1.4c-1.3-0.7-2-1.1-2.9-1.1c-1,0-1.5,1.1-1.6,2.9H422.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M463.8,288.2l-7.7,9.2h-3.9l5.6-9.2H463.8z M452.1,332.1v-31h5.6v31H452.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M488.6,324.7c0,2.7,0.1,5.3,0.4,7.4h-5l-0.5-3.9h-0.2c-1.6,2.4-5,4.6-9.4,4.6c-6.2,0-9.4-4.4-9.4-8.9 c0-7.5,6.6-11.6,18.5-11.5v-0.6c0-2.6-0.7-7.2-7-7.2c-2.9,0-5.9,0.8-8.1,2.3l-1.3-3.8c2.5-1.6,6.3-2.7,10.2-2.7 c9.5,0,11.7,6.5,11.7,12.7V324.7z M483.1,316.3c-6.1-0.1-13,1-13,7c0,3.7,2.4,5.4,5.2,5.4c4.1,0,6.7-2.6,7.6-5.2 c0.2-0.6,0.3-1.2,0.3-1.8V316.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M537.5,286.7v37.4c0,2.8,0.1,5.9,0.3,8h-5l-0.3-5.4h-0.1c-1.7,3.5-5.4,6.1-10.4,6.1 c-7.4,0-13.2-6.3-13.2-15.7c-0.1-10.4,6.3-16.6,13.8-16.6c4.8,0,7.9,2.2,9.3,4.7h0.1v-18.4H537.5z M531.9,313.8 c0-0.8-0.1-1.7-0.3-2.4c-0.8-3.5-3.9-6.5-8.1-6.5c-5.8,0-9.2,5.1-9.2,11.9c0,6.3,3.1,11.5,9.1,11.5c3.7,0,7.2-2.6,8.2-6.7 c0.2-0.8,0.3-1.5,0.3-2.4V313.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M549.9,317.6c0.1,7.6,4.9,10.7,10.5,10.7c4,0,6.5-0.7,8.5-1.5l1,4c-2,0.9-5.4,2-10.3,2 c-9.4,0-15.1-6.3-15.1-15.6c0-9.4,5.5-16.8,14.5-16.8c10,0,12.6,8.9,12.6,14.6c0,1.2-0.1,2-0.2,2.7L549.9,317.6z M566.3,313.6 c0.1-3.5-1.5-9.2-7.7-9.2c-5.7,0-8.1,5.2-8.6,9.2H566.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M591.5,325.4c2.5,1.6,6,2.8,9.8,2.8c5.6,0,8.9-2.9,8.9-7.4c0-4-2.3-6.3-8.1-8.5c-7-2.6-11.3-6.3-11.3-12.3 c0-6.7,5.5-11.7,13.8-11.7c4.3,0,7.6,1,9.4,2.1l-1.5,4.5c-1.3-0.8-4.2-2-8.1-2c-5.8,0-8.1,3.5-8.1,6.5c0,4,2.6,6,8.5,8.3 c7.2,2.9,10.9,6.3,10.9,12.7c0,6.7-4.8,12.5-14.9,12.5c-4.1,0-8.6-1.3-10.9-2.8L591.5,325.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M626.9,317.6c0.1,7.6,4.9,10.7,10.5,10.7c4,0,6.5-0.7,8.5-1.5l1,4c-2,0.9-5.4,2-10.3,2 c-9.4,0-15.1-6.3-15.1-15.6c0-9.4,5.5-16.8,14.5-16.8c10,0,12.6,8.9,12.6,14.6c0,1.2-0.1,2-0.2,2.7L626.9,317.6z M643.2,313.6 c0.1-3.5-1.5-9.2-7.7-9.2c-5.7,0-8.1,5.2-8.6,9.2H643.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M681.8,327.6c0,7.2-1.5,11.5-4.4,14.2c-3,2.8-7.4,3.7-11.2,3.7c-3.7,0-7.7-0.9-10.2-2.6l1.4-4.4 c2,1.3,5.2,2.5,9,2.5c5.7,0,9.9-3,9.9-10.9v-3.4h-0.1c-1.7,2.9-5,5.2-9.8,5.2c-7.6,0-13.1-6.5-13.1-15.2 c0-10.5,6.8-16.4,13.9-16.4c5.3,0,8.2,2.8,9.6,5.3h0.1l0.2-4.6h5c-0.2,2.2-0.3,4.7-0.3,8.4V327.6z M676.2,313.3 c0-0.9-0.1-1.7-0.3-2.5c-1-3.3-3.7-6-7.8-6c-5.3,0-9.1,4.5-9.1,11.8c0,6,3.1,11.1,9.1,11.1c3.5,0,6.6-2.2,7.7-5.8 c0.3-0.9,0.4-2,0.4-3V313.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M716.7,323.7c0,3.2,0.1,6,0.3,8.4h-5l-0.3-5.1h-0.1c-1.4,2.5-4.7,5.8-10.2,5.8c-4.8,0-10.6-2.8-10.6-13.6 v-18.1h5.6v17.1c0,5.9,1.8,9.9,6.9,9.9c3.7,0,6.3-2.6,7.4-5.2c0.3-0.8,0.5-1.8,0.5-2.9v-18.9h5.6V323.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M726,310.8c0-3.6-0.1-6.8-0.3-9.7h4.9l0.3,6.1h0.2c1.4-4.2,4.8-6.8,8.6-6.8c0.6,0,1,0.1,1.5,0.2v5.2 c-0.6-0.1-1.2-0.1-2-0.1c-3.9,0-6.7,3-7.5,7.2c-0.1,0.8-0.2,1.7-0.2,2.7v16.5h-5.6L726,310.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M758.8,332.8c-8.2,0-14.7-6.1-14.7-15.9c0-10.4,6.8-16.4,15.2-16.4c8.8,0,14.8,6.5,14.8,15.9 C774.1,327.8,766.2,332.8,758.8,332.8L758.8,332.8z M759,328.6c5.3,0,9.3-5.1,9.3-12.1c0-5.2-2.6-11.8-9.2-11.8 c-6.5,0-9.4,6.1-9.4,12C749.7,323.5,753.5,328.6,759,328.6L759,328.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M780.4,326.4c1.7,1,4.6,2.2,7.4,2.2c4,0,5.9-2,5.9-4.6c0-2.7-1.6-4.2-5.6-5.7c-5.6-2-8.2-5.1-8.2-8.8 c0-5,4.1-9.1,10.6-9.1c3.1,0,5.8,0.8,7.5,1.9l-1.3,4c-1.2-0.7-3.4-1.8-6.3-1.8c-3.3,0-5.1,1.9-5.1,4.2c0,2.6,1.8,3.8,5.8,5.3 c5.3,2,8.1,4.7,8.1,9.3c0,5.5-4.3,9.3-11.4,9.3c-3.4,0-6.5-0.9-8.6-2.2L780.4,326.4z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M209.2,223.4c0,12.2-9.9,22.1-22.1,22.1H25.8c-12.2,0-22.1-9.9-22.1-22.1V86c0-12.2,9.9-22.1,22.1-22.1 h161.3c12.2,0,22.1,9.9,22.1,22.1V223.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M83,184.9l9.6-13.2c0,0,2.7-2.5-3-6.6c-5.7-4.1-13.2-13-12.6-17.4c0.7-4.3-6.2,3-4.6,7.5 c1.6,4.6,8.2,12.3,9.8,13c1.6,0.7,3.2,2.3,0.9,4.6C81,175.1,78.7,180.3,83,184.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M96.3,211.6c4.3,2.1,9.4,0.7,15.5-2.7c6.2-3.4,12.1-1.8,16.7,0.7c4.6,2.5,4.8,2.5,3.4-0.2 c-1.4-2.7-11.6-8-11.6-8s-0.2-9.4,0-9.6c2.5-2.5,5.7-2.3,10.3-6.4c4.6-4.1,0.2-9.1-0.5-8c-1.4,2.4-5.3,7.3-13.2,6.6 c-8-0.7-11.9-7.5-11.9-7.5c-7.1,7.1,11.9,14.6,11.9,14.6l-0.5,6.2c0,0,0,3.2-1.4,4.8c-1.4,1.6-10.3,5.5-13.2,6.2 c-3,0.7-8.5-1.8-10.5-3c-2.1-1.1-2.5-3-2.7-0.7C88.3,206.9,91.9,209.6,96.3,211.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M122.3,156.4c0.1,0.4,0.2,0.7,0.3,0.7C122,155.1,121.7,154.3,122.3,156.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M151.5,148.1c-0.5-3.9-2.1-4.8-7.8-5c-5.7-0.2-12.5,0.7-16.1,3.4c-3.7,2.7-12-7.4-19.5-4.2 c-7.5,3.2-7.9,8.8-9.5,9.2c-1.6,0.5-1.1-1.1-4.3-3.7c-3.2-2.5-11.4-2.3-12.6-1.8c-1.1,0.5-2.7,5.7,2.4,7.5 c5,1.8,9.3-0.2,11.6,1.4c2.3,1.6,2.2,4.5,3.8,3.8c1.6-0.7,2.9-4.9,5.8-7.2c4-3.3,6.9-3.3,11.7-2.5c4.9,0.8,6.2,8.4,5.7,8 c1,3,2.8,8.7,3.4,10.5c0.9,3-0.9,5.3,2.3,5.7c3.2,0.5,0.9-1.4,1.4-4.6c0.5-3.2-1.6-11.2,0.7-13.2c2.3-2.1,1.1-4.3,3.7-3.9 c2.5,0.5,4.1,0.5,5.9-0.2c1.8-0.7,7.1-7.1,7.5-4.1c0.5,3-3.2,5.9-4.6,6.6c-1.4,0.7-4.6,3.2-4.6,4.1c0,0-4.8,9.1,0.7,5.9 C144.5,160.6,152.2,153.9,151.5,148.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M117.5,234.2l11,14.2l10.5,0.2L126.9,234C126.9,234,121.4,235.2,117.5,234.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M96.5,229.4c-3.4-2.3,12.3,20.6,12.3,20.6l9.1-1.4L106.8,234C106.8,234,99.9,231.7,96.5,229.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M87.6,215.7c-3.2-8.5-4.3-12.8-6.4-10.5c-2.1,2.3-0.5,14.4,2.1,22.8c2.5,8.5,7.5,19,7.5,19l7.3,2.7 c0,0-8-15.8-8.2-20.1C89.6,225.3,90.8,224.2,87.6,215.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M76.2,200.4c1.1-3.7,2.1-6.4,2.1-6.4s-3.9-4.6-6.2-0.5c-2.3,4.1-4.8,16.2-3.9,24c0.9,7.8,4.3,21.7,5.7,24.4 c1.4,2.7,5.9,9.4,5.9,9.4l4.1-3.7c0,0-9.6-16-9.1-26.3C75.2,211.2,75,204.1,76.2,200.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M66.1,198.8c1.6-3.4,4.8-9.4,4.8-9.4l-4.1-2.1c0,0-6.2,7.8-9.4,20.8c-3.2,13-0.5,33.1,4.8,40.7 c5.3,7.5,6.2-2.5,6.2-2.5s-6.6-12.6-7.1-21.5C60.9,216,64.5,202.3,66.1,198.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M50.8,208.4C52.4,197,64.3,186,64.3,186l-2.1-5.7c0,0-18,12.8-19.6,30.4c-1.6,17.6,4.8,38.4,4.8,38.4 s8.5,5.9,6.2-0.5S49.2,219.9,50.8,208.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M38.9,199.8c4.8-13.7,21.2-21.9,21.2-21.9l-1.8-6.2c-19.4,11.4-29.2,31.7-31.1,45.5 c-1.8,13.7,3.7,31.1,3.7,32.7s8.5,0.2,8.5,0.2l-4.6-17.1C34.8,232.9,34.1,213.5,38.9,199.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M28.6,193.8c5.7-15.8,28.8-25.6,28.8-25.6l-0.2-5.7c0,0-7.5,0.9-21.7,13.2c-14.2,12.3-19,27.2-20.6,39.3 c-1.6,12.1,2.5,32.9,2.7,34.7c0.2,1.8,7.5,1.8,7.5,1.8s-2.1-6.4-3.9-21.5C19.5,215.1,22.9,209.6,28.6,193.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M17,186.5c21.9-23.3,39.7-26.3,39.7-26.3l-0.2-7.3c0,0-10.3-0.7-25.6,11.6c-31.3,25.4-32.2,47.5-32.2,48.7 c0,1.1,8,33.6,8,33.6s10.3,18.7,6.2,0.2S5.4,206.8,17,186.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M54.5,149.3l2.1-5c-25.1-0.9-59.8,32.9-59.8,32.9l-2.5,19C19.7,155.7,54.5,149.3,54.5,149.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M-4.2,157.7v11.2c0,0,13.7-13.5,27.9-21.7c14.2-8.2,33.8-6.9,33.8-6.9l2.3-4.6c0,0-4.8-0.7-23.8,2.1 C17,140.6-4.2,157.7-4.2,157.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M2.8,149.7c0,0,5.5-14.8,37-17.1c0,0-6.6-18.7-0.7-30.4c-6.4-2.1-31.7,3.4-34.9,6.9 c-3.2,3.4-7.3,4.1-7.3,4.1l1.6,6.4c0,0,13.7-9.8,21.2-11.6c7.5-1.8,14.2-1.4,14.2-1.4l-1.1,7.1c0,0-19-4.8-36.1,15.1 c-17.1,19.9-1.4,11.4-1.4,11.4s8.5-18.5,37-22.2c0,0,1.4,7.3,2.1,9.1c0.2-0.2-10.5-3.9-38.4,15.8c-27.9,19.6,3.2,5.9,3.2,5.9 L2.8,149.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M66.6,127.3L54,127.1c0,0-1.6-2.7-1.8-4.8c-0.2-2.1-4.1-4.3-4.1-4.3l0.2-8.9c-3.9-1.6-5.9,1.6-5.9,1.6 l-1.1,11.9c0,0,1.8,0.7,4.1,3.9c2.3,3.2,2.5,6.6,2.5,6.6l13.7-0.5L66.6,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M82.3,116.6c-10.5-11.6-39.5-16.4-39.5-16.4l0.5,3c0,0,4.6-0.2,10.5,5.9c5.9,6.2,2.7,7.8,6.6,12.6 c3.9,4.8,8.7,2.3,8.7,2.3s3.4,0.2,2.7-3.4c-0.7-3.7-9.1-3.2-9.1-3.2s-2.5-2.3-2.5-5.9c6.4,0.5,9.6,4.1,12.6,6.6 C75.7,120.5,84.8,118.7,82.3,116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M-3.3,106.3c0,0,11.6-14.2,41.8-11.6c30.2,2.5,39.3,13.5,42.3,15.3c0,0,9.1,7.5,8,2.3 c-1.1-5.3-21.9-20.1-37.9-23.8C34.8,84.9,4,89-5.4,99.5C-34.8,112.7-3.3,106.3-3.3,106.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M-2.4,94.2c0,0,24.2-20.1,49.8-13.2C73,87.8,79.1,96.7,91,105.4c0,0,14.4,16.2,8.5,2.3 c-5.9-13.9-33.6-28.3-41.1-30.2c-7.5-1.8-31.1-8.2-57.3,7.5C-25.3,100.9-2.4,94.2-2.4,94.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M1,79.6c0,0,22.6-13.2,42.3-10.7c19.6,2.5,36.3,5.3,50.7,24c14.4,18.7,17.6,19,14.6,10.3 c-3-8.7-29.9-32.2-38.6-36.1c-8.7-3.9-53.4-9.8-62.8-4.8C-2.2,67.3-3.3,80.1,1,79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M79.4,56c0.2,0.9,1.9,7.9,9.6,13.6c8.2,6.2,13.7,12.6,18.5,20.8c4.8,8.2,6.2,15.8,6.2,15.8s5.9,8.5,6.4,4.6 c0.5-3.9-4.6-34.3-27-50c-22.4-15.8-14.6-5-14.6-5L79.4,56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M121.6,89.2c4.3,14.6,3.7,20.1,3.7,20.1s5.3,6.9,5.3-5.7s-8.2-32.7-20.8-44.3c-12.6-11.6-7.1,4.1-7.1,4.1 S117.3,74.6,121.6,89.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M133.9,86.7c4.8,20.1,1.6,26.5,1.6,26.5l4.3,3.4c0,0,5.3-16.4,1.8-27.9c-3.4-11.4-7.3-23.3-14.8-31.1 c-7.5-7.8-7.8,4.1-7.8,4.1S129.1,66.6,133.9,86.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M171.5,117.8c0.1-0.7,0.1-1.2,0.1-1.2C171.3,118,171.4,118.3,171.5,117.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M146.1,74.6c1.1,7.3,3.2,17.8,1.4,29.9s-3.9,13.7-3.9,13.7l3.7,4.8c0,0,5.5-22.2,17.6-24.7 c4-0.2,6.6,2.7,7.5,6.2c1.3,4.9-0.3,11.9-0.8,13.3c-0.2,1.8-0.5,5.2-1.2,6.3c-0.9,1.5-2.1,5.9-4.3,5.9s-8.5,2.1-8.5,2.1 s-0.9,7.3,0.2,8.7c1.1,1.4,4.3-0.8,7.6-4.3c3.3-3.5,12.3-18.3,14.3-30.5c2-12.2,0.8-27-0.2-35.2c-0.9-8.2-2-10.5-4-11.1 c-2-0.6-7.3-0.5-5.8,3.2c1.5,3.7,1.2,2.4,3.2,11.3c2,8.8,1.2,15.7,0.9,18.4c-0.3,2.7-1.5,6.1-1.5,6.1s-0.6-1.5-2.7-2.4 c-2.1-0.9-1.4-18.3-3.2-23c-1.8-4.7-2.4-13.7-5.3-13.7c-2.9,0-5.2,0.2-5.5,1.2c-0.3,1.1,1.5,4.9,2.6,7.8c1.1,2.9,4,14.2,4,19.2 c0,5-0.5,7.8-0.5,7.8s-5.8,3-7.2,5.9c-1.4,2.9,1.1-11.6,0.5-16.1c-0.6-4.6-5.9-21.9-8.8-23.8c-2.9-1.8-2.4-9-2.4-9l-7.1,9.4 C136.7,62,144.9,67.3,146.1,74.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M165.2,142.3c-9.3,4.3-7.8,3.8-8.1,7.6c-0.3,3.8,1,3.8,3.3,2.7s21-15.2,24.4-21c0,0,11.9-17.4,11.7-36.2 c-0.2-18.9-2.1-26.8-5-32.6c-2.9-5.8-5.6-5.9-5.6-5.9s-2.7,3.5-0.8,7.5c2,4,6.5,12.5,6.7,26.6s-6.9,28.6-8.7,32.4 C181.2,127.3,174.5,138.1,165.2,142.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M200.9,114.6c-4.6,9.4-10.4,22.5-19.6,28.9c-9.3,6.4-18.7,12.6-22.7,13.6c-4,0.9-4.1,5.8-2,6.4 c2.1,0.6,27.3-11.1,35.3-21.6c8.1-10.5,17.1-20.4,19.9-27.4c2.9-7,10.5-35.6,5.3-43.6c-5.2-7.9-11.7-14.3-11.7-14.3l-9.4,9.3 c0,0,6.1,8.8,6.7,15.5C203.4,88.1,205.5,105.2,200.9,114.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M188.3,155.6c-12.9,8.5-29.2,12.9-32,12.9c-1.4-0.2,0.2,5.2,1.1,5.2c0.9,0,20.7-2.4,32.3-11.6 c11.6-9.1,21.8-19.8,24.5-24.1c2.7-4.3,3.3-18.1,3.3-18.1S201.3,147.1,188.3,155.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M184.8,178.3c12.2-6.1,29.8-18,29.8-18l-0.8-10.7c0,0-16.1,18.7-32.1,24.1c-16,5.3-27,2.9-27,2.9l-1.4,5.5 C153.4,182.1,172.6,184.4,184.8,178.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M213.7,168.1c0,0-19,15.5-32.9,18s-29.1-0.8-29.1-0.8l-2.4,5.5c0,0,20.7,4.7,33.8-0.2 c13.1-4.9,28.3-10.2,32.4-15.8C219.7,169.1,213.7,168.1,213.7,168.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M176,204.6c17.7-1.4,32.6-5.9,37.2-10.5l1.1-8.2c0,0-18.6,12.8-35.2,12.2c-16.6-0.6-28.8-3-29.7-3 c-0.9,0-3.5,7-3.5,7S158.3,206,176,204.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M212.4,213.9c-4.3,2.1-23.8,15.8-42.3,13.1s-26.3-9.7-28.3-13.1c-2-3.3-0.9-5.2,4-3.2 c4.9,2,6.9,6.7,29.1,8.4c16.8,3.3,40.5-12.6,40.5-12.6l-5.2-3.8c0,0-21.3,11-36.5,10.7c-15.2-0.3-19.9-3.4-23.8-5.9 c-3.8-2.6-9.1-1.7-11.7,0.8c-2.4,0.5-3.4,5-3,6.2c0.3,1.2,7,8.2,20.4,14.5s44.2-1.2,50.1-4c5.9-2.7,10.5-0.6,10.5-0.6 S216.6,211.8,212.4,213.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M135.6,227.3l-1.2,5.3c0,0,1.4,0.6,9.1,5.2c7.8,4.6,22.9,9.7,38.4,8.4c19.8-1.7,28.9-9,28.9-9l1.4,6.4 l0.3-18.3c-10.2,9.6-19.9,12.2-39,14.2C154.5,241.5,135.6,227.3,135.6,227.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#01538F"
    },
    d: "M162.5,118.2c2.1-6.9,3.2-6.6,3.2-9.8c0-5.3-5.5-5-7.3-1.6c-1.8,3.4-2.3,6.6-2.5,8.9s-2.3,6.6-2.3,6.6 l-0.9,3l2.5,3.4C155.2,128.7,160.4,125.1,162.5,118.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssa);
export default __webpack_public_path__ + "static/media/ASSA.f119bad2b49ecd01926bb4e26a99e700.svg";
export { ForwardRef as ReactComponent };